export default "__VITE_ASSET__qGIsEI4W__"